export type Article = {
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  category: "官方发布" | "剧情解读" | "角色深度" | "行业观察";
  author: string;
  body: string[];
  tags: string[];
};

export const articles: Article[] = [
  {
    id: "news-01",
    title: "《朋友的妈妈3》首支预告发布，雨夜重逢引爆期待",
    summary:
      "官方发布首支正式预告，短短九十秒呈现出浓郁的蓝色雨夜氛围，程野与苏晚晴的巷口重逢成为最大悬念。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20style%20image%20of%20a%20rainy%20night%20city%20alley%20with%20a%20lone%20figure%20holding%20an%20umbrella%2C%20deep%20blue%20atmosphere%20with%20warm%20orange%20street%20glow%2C%20dramatic%20poster%20composition%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-01&orientation=landscape",
    date: "2026-09-08",
    category: "官方发布",
    author: "本站编辑部",
    body: [
      "官方于本周正式发布《朋友的妈妈3》首支预告片。预告全长九十秒，几乎没有对白，全部依靠画面与雨声推进情绪。",
      "开篇是一段长达十余秒的俯拍镜头：暴雨中的旧城巷道，路面积水倒映着暖色路灯。这也是全片最具辨识度的视觉符号。",
      "预告结尾，程野推开老屋的门，画面定格在一张合影上，配文只有一句：「有些真相，迟到十年。」",
      "官方同时确认，《朋友的妈妈3》将延续前作的家庭叙事基调，但在影像风格上进行了明显升级，强化了蓝调夜景与暖色对比。",
    ],
    tags: ["预告", "官方", "定档"],
  },
  {
    id: "news-02",
    title: "深度解读：为什么全片都在下雨？",
    summary:
      "雨是《朋友的妈妈3》里反复出现的意象。本文从影像符号的角度，解读导演为何让这座旧城始终笼罩在雨中。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20heavy%20rain%20on%20a%20dark%20street%20with%20reflections%2C%20deep%20blue%20tones%20and%20warm%20orange%20light%20points%2C%20moody%20analytical%20atmosphere%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-02&orientation=landscape",
    date: "2026-09-15",
    category: "剧情解读",
    author: "影评人 · 江阔",
    body: [
      "如果说前作的关键词是「沉默」，那么《朋友的妈妈3》的关键词无疑是「雨」。",
      "雨在本片中出现得极为频繁，几乎每一场重要戏份都伴随着降水。这并非偶然，而是一种刻意的情绪外化。",
      "从叙事上看，雨既是阻隔，也是清洗。它隔开了人物之间想说的话，又在洗刷旧城里那些不愿被记起的往事。",
      "导演在受访时曾表示：「我没有拍雨，我拍的是每个人心里那场没停过的雨。」",
    ],
    tags: ["解读", "影像", "符号"],
  },
  {
    id: "news-03",
    title: "角色深度：苏晚晴不是反派，她只是选择了沉默",
    summary:
      "播出过半，苏晚晴这个角色引发大量讨论。本文尝试还原她的行为逻辑，解释她为何始终不肯说出真相。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20still%20of%20a%20woman%20in%20deep%20blue%20shadow%20with%20a%20warm%20orange%20rim%20light%2C%20mysterious%20restrained%20expression%2C%20artistic%20film%20portrait%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-03&orientation=landscape",
    date: "2026-09-28",
    category: "角色深度",
    author: "本站编辑部",
    body: [
      "苏晚晴这个角色，在前几章里几乎一直是「被误解」的。她不解释、不辩驳，甚至主动承担了观众的敌意。",
      "但把她的所有戏份串起来看，会发现她的每一次沉默都对应着一次保护。她守住的秘密，恰恰是为了守住程野。",
      "演员林知夏在采访中说：「她不是不想说，是说出来会伤害更多人。沉默对她是成本最低的善良。」",
    ],
    tags: ["角色", "苏晚晴", "解读"],
  },
  {
    id: "news-04",
    title: "官方更新：第一季全十章播出时间表公布",
    summary:
      "官方公布第一季完整播出排期，全十集正片加两集特别篇，将连续四周陆续上线。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20calendar%20and%20notebook%20on%20a%20desk%20under%20warm%20lamp%2C%20deep%20blue%20dark%20room%20background%2C%20organized%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-04&orientation=landscape",
    date: "2026-09-22",
    category: "官方发布",
    author: "本站编辑部",
    body: [
      "官方于本周公布《朋友的妈妈3》第一季的完整播出时间表。全季共十集正片，另附两集特别篇。",
      "正片自九月起每周一集，特别篇分别在第六集与终章后上线，用于补完角色视角与幕后制作内容。",
      "官方提醒观众，特别篇并非简单花絮，其中包含大量主线未呈现的剧情线索，建议按顺序观看。",
    ],
    tags: ["更新", "播出", "官方"],
  },
  {
    id: "news-05",
    title: "幕后：一场雨戏拍了六个通宵",
    summary:
      "为了拍出真实质感，剧组坚持等一场真雨。摄影指导分享那场标志性雨戏背后的六个通宵。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20of%20a%20night%20film%20shoot%20in%20the%20rain%2C%20crew%20and%20camera%20under%20deep%20blue%20lights%20with%20warm%20orange%20practicals%2C%20documentary%20atmosphere%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-05&orientation=landscape",
    date: "2026-10-02",
    category: "行业观察",
    author: "本站编辑部",
    body: [
      "第一集中那场三分半钟的无对白雨戏，是很多观众记住这部作品的原因。而它的诞生并不轻松。",
      "摄影指导透露，剧组拒绝了棚内造雨方案，坚持在真实巷道里等雨。结果整整等了六天，七个通宵。",
      "「我们不要漂亮的雨，我们要真的雨。」这句话后来成了整个摄制组的口头禅。",
    ],
    tags: ["幕后", "制作", "摄影"],
  },
  {
    id: "news-06",
    title: "解读：那句「这张照片是什么时候拍的」有多重",
    summary:
      "第一集的收官台词只有一句，却贯穿了整个第一季。本文梳理这句台词在后续章节中的四次回响。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20hands%20holding%20an%20old%20photograph%20in%20dim%20blue%20light%20with%20warm%20orange%20edge%2C%20mysterious%20intimate%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-06&orientation=landscape",
    date: "2026-10-06",
    category: "剧情解读",
    author: "影评人 · 江阔",
    body: [
      "「这张照片，是什么时候拍的？」——这是程野回到旧城后问出的第一句话，也是全季的结构性台词。",
      "它先后在第一、三、六、九章以不同形式回响，每一次问的人、答的人都不同，含义也随之层层加深。",
      "到了第九章，这个问题终于被回答，但答案带来的不是结束，而是更大的追问。",
    ],
    tags: ["解读", "台词", "结构"],
  },
  {
    id: "news-07",
    title: "配乐特辑：全季主题旋律只响两次",
    summary:
      "配乐团队透露，《朋友的妈妈3》刻意保持克制，主题旋律全季仅完整出现两次，一次开场，一次终章。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20recording%20studio%20with%20a%20piano%20under%20warm%20spotlight%2C%20deep%20blue%20dark%20room%20background%2C%20intimate%20musical%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-07&orientation=landscape",
    date: "2026-10-09",
    category: "行业观察",
    author: "本站编辑部",
    body: [
      "在这个「配乐越满越好」的年代，《朋友的妈妈3》选择了一条相反的路。",
      "配乐团队表示，全片大量段落完全依靠环境音推进，主题旋律只在开场与终章各完整出现一次。",
      "「不用音乐去告诉观众该难过了，让画面和雨声自己说话。」",
    ],
    tags: ["配乐", "声音", "幕后"],
  },
  {
    id: "news-08",
    title: "官方答疑：第二季会有哪些新角色？",
    summary:
      "针对观众高频提问，官方整理了一份答疑合集，透露第二季将引入两条新的家庭线与一位关键新角色。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20group%20of%20unseen%20silhouettes%20standing%20in%20a%20blue%20lit%20corridor%20with%20warm%20orange%20doorway%20glow%2C%20mysterious%20anticipatory%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-08&orientation=landscape",
    date: "2026-10-12",
    category: "官方发布",
    author: "本站编辑部",
    body: [
      "随着第一季收官在即，官方集中回答了观众最关心的几个问题。",
      "被问及第二季是否会引入新角色时，官方给出了肯定答复：将新增两条家庭线，以及一位「第一季只出现过名字」的关键人物。",
      "官方同时强调，所有新角色都将与旧城这张关系网产生直接关联，不会为了扩展而扩展。",
    ],
    tags: ["答疑", "第二季", "官方"],
  },
  {
    id: "news-09",
    title: "深度：旧城取景地为何如此让人难忘",
    summary:
      "作品中的旧城并非影棚搭建，而是一处真实存在的老街区。本文走近这些取景地，看空间如何参与叙事。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20old%20abandoned%20city%20district%20at%20blue%20hour%20with%20warm%20distant%20lights%2C%20quiet%20atmospheric%20melancholic%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-09&orientation=landscape",
    date: "2026-10-10",
    category: "剧情解读",
    author: "影评人 · 江阔",
    body: [
      "《朋友的妈妈3》的空间感，是它区别于同类作品的最大特点之一。",
      "剧中的旧城并非影棚搭建，而是一处真实存在、正在逐渐搬迁的老街区。狭窄的巷道、共用的楼道、永远亮着灯的窗户，都是真实空间。",
      "空间在这里不只是背景，它本身就是角色。楼道有多窄，人物之间就有多近；巷子有多长，程野的那句追问就有多沉。",
    ],
    tags: ["取景", "空间", "解读"],
  },
  {
    id: "news-10",
    title: "收官前瞻：终章的三条线索会如何收束",
    summary:
      "第一季即将收官，本文梳理目前仍悬而未决的三条核心线索，并给出基于文本的合理推测。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20lone%20lit%20window%20in%20a%20dark%20old%20building%20at%20night%2C%20deep%20blue%20shadows%20with%20warm%20orange%20interior%20glow%2C%20suspenseful%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=fm3-news-10&orientation=landscape",
    date: "2026-10-13",
    category: "剧情解读",
    author: "本站编辑部",
    body: [
      "第一季收官在即，目前仍有三条核心线索尚未完全收束：被撕掉的相册页、父亲的名字、天台上未说完的话。",
      "从已播出的文本来看，这三条线索很可能在同一场戏中交汇。",
      "无论结局如何，这部作品已经把「家」这个主题讲得足够诚实。",
    ],
    tags: ["收官", "前瞻", "线索"],
  },
];